import { useEffect, useRef, useState } from 'react';
import * as React from 'react';

import ExploreSubPage from 'bundles/composable-page-header/components/mobile-menu-items/ExploreSubPage';
import type { MobileExploreIdentifierValues } from 'bundles/composable-page-header/constants';
import { MegaMenuDataProviderWithHOC } from 'bundles/composable-page-header/providers/MegaMenuDataProvider';
import type { MenuItem } from 'bundles/megamenu/types/MenuData';

type Props = {
  identifier: MobileExploreIdentifierValues;
};

export const ExploreCustomConsumerSubmenu = (props: Props) => {
  const { identifier } = props;
  const [exploreViewState, setExploreViewState] = useState<MobileExploreIdentifierValues>(identifier);
  const [currentMenuItem, setMenuItem] = useState<MenuItem | undefined>(undefined);
  const mobileBackBtnRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    // When entering a subpage, focus on the back button so the page scrolls to the top
    if (mobileBackBtnRef.current instanceof HTMLElement) {
      mobileBackBtnRef.current.focus();
    }
  }, [currentMenuItem, mobileBackBtnRef]);

  return (
    <div>
      <ExploreSubPage
        exploreViewState={exploreViewState}
        setExploreViewState={setExploreViewState}
        setMenuItem={setMenuItem}
        currentMenuItem={currentMenuItem}
      />
    </div>
  );
};

const WrappedExploreCustomConsumerSubmenu = (props: Props) => (
  <MegaMenuDataProviderWithHOC isEnterprise={false}>
    <ExploreCustomConsumerSubmenu {...props} />
  </MegaMenuDataProviderWithHOC>
);

export default WrappedExploreCustomConsumerSubmenu;
